(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["countdown"] && !Shopify.designMode) return;
  try {
    (() => {
    const countdowns = document.querySelectorAll('.countdown[data-countdown]');
    if (!countdowns.length) return;

    const getNextEndDate = (targetDay) => {
      const now = new Date();
      const today = now.getDay();
      const target = targetDay === 7 ? 0 : Number(targetDay);
      let delta = target - today;
      if (delta < 0) delta += 7;
      if (delta === 0) {
        const endToday = new Date(now);
        endToday.setHours(23, 59, 59, 999);
        if (endToday.getTime() > now.getTime()) return endToday;
        delta = 7;
      }
      const end = new Date(now);
      end.setDate(now.getDate() + delta);
      end.setHours(23, 59, 59, 999);
      return end;
    };

    const updateCountdown = (countdown) => {
      const dayEnd = Number(countdown.dataset.dayEnd || 7);
      const endDate = getNextEndDate(dayEnd);
      const now = new Date();
      let diff = endDate.getTime() - now.getTime();
      if (diff < 0) diff = 0;

      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      const setValue = (key, value) => {
        const node = countdown.querySelector(`[data-countdown-value="${key}"]`);
        if (node) node.textContent = value;
      };

      const setLabel = (key, value) => {
        const node = countdown.querySelector(`[data-countdown-label="${key}"]`);
        if (!node) return;
        const singular = countdown.dataset[`label${key.charAt(0).toUpperCase()}${key.slice(1)}Singular`];
        const plural = countdown.dataset[`label${key.charAt(0).toUpperCase()}${key.slice(1)}Plural`];
        node.textContent = value === 1 ? singular || node.textContent : plural || node.textContent;
      };

      setValue('days', days);
      setValue('hours', String(hours).padStart(2, '0'));
      setValue('minutes', String(minutes).padStart(2, '0'));
      setValue('seconds', String(seconds).padStart(2, '0'));

      setLabel('days', days);
      setLabel('hours', hours);
      setLabel('minutes', minutes);
      setLabel('seconds', seconds);

    };

    countdowns.forEach((countdown) => {
      updateCountdown(countdown);
      if (countdown._countdownInterval) clearInterval(countdown._countdownInterval);
      countdown._countdownInterval = setInterval(() => updateCountdown(countdown), 1000);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
